export const STORE_DELIVERY_ADDRESS = {
  type: 'store',
  _id: 'STORE_ID',
  title: 'Bio Culture',
  address: '12 Rue Jean-Baptiste Huet',
  zipCode: '78350',
  city: 'Jouy-en-Josas',
  complement: '',
  comment: '',
};
